export default {
  init() {
    // JavaScript to be fired on the home page
    var productsRotationSpeed = 2000;
    function setProductClaimByProduct(e){
      $('#product-claim').html(e.find('.product-claim').first().html());
      $('#product-claim').removeClass('not-inited');
      $('#product-claim .line-2').delay(300).animate({opacity: 1}, 500);
    }

    function rotateProductClaim(){
      if(!$('.products-wrap').hasClass('hover') && ($('#product-claim').is( ':in-viewport' ) || $('#product-claim').hasClass('not-inited')) ){
        var nextOne = null;
        var found = false;
        $('.products-wrap .product').each(function(){
          if(found && nextOne == null){
            nextOne = $(this);
          }
          if($(this).hasClass('like-hover')){
            found = true;
          }
        });
        nextOne = nextOne == null ? $('.products-wrap .product').first() : nextOne;
        $('.products-wrap .product').removeClass('like-hover');
        nextOne.addClass('like-hover');
        setProductClaimByProduct(nextOne);
      }


      setTimeout(function(){
        rotateProductClaim();
      },productsRotationSpeed);
    }
    rotateProductClaim();

    $('.products-wrap a').on('mouseenter',function(){
      $('.products-wrap').addClass('hover');
      $('.products-wrap .product').removeClass('like-hover');
      setProductClaimByProduct($(this));
    });
    $('.products-wrap a').on('mouseleave',function(){
        $('.products-wrap').removeClass('hover');
        $(this).addClass('like-hover');
        setProductClaimByProduct($('.products-wrap .product.like-hover').first());
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js